import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchWithdrawalHistory = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("referandearn/commissions-withdrawal-history/list?searchFilter=" + data.searchFilter + "&userID=" + data.userID);
    }, options);
};
